import './PortContactPop.css'
import 'antd/dist/reset.css'
import React from 'react'
import { Popover, FloatButton, Space } from 'antd'
import { PhoneOutlined, MailOutlined } from '@ant-design/icons'

export default class PortContactPop extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {}

  render() {
    return (
      <div
        style={{
          position: 'fixed',
          top: '90vh',
          right: '3vw',
          zIndex: 200,
        }}
      >
        <Popover title={this.getContactTitle()} content={this.getContactInfo()}>
          <FloatButton icon={<PhoneOutlined />} />
        </Popover>
      </div>
    )
  }

  getContactTitle = () => {
    return <div className="PortContactPopTitle">联系我们</div>
  }

  getContactInfo = () => {
    return (
      <div className="PortContactPopWrapper">
        <div className="PortContactPopPosition">商务</div>
        <div className="PortContactPopContentWrapper">
          <Space>
            <PhoneOutlined style={{ fontSize: 14 }} />
            <div className="PortContactPopContentMethod">电话</div>
          </Space>
          <div className="PortContactPopContentName">17625997856</div>
        </div>
        <div className="PortContactPopContentWrapper">
          <Space>
            <MailOutlined style={{ fontSize: 14 }} />
            <div className="PortContactPopContentMethod">邮箱</div>
          </Space>
          <div className="PortContactPopContentName">
            sales@keystridevalve.com
          </div>
        </div>

        <div className="PortContactPopPosition">技术</div>
        <div className="PortContactPopContentWrapper">
          <Space>
            <PhoneOutlined style={{ fontSize: 14 }} />
            <div className="PortContactPopContentMethod">电话</div>
          </Space>
          <div className="PortContactPopContentName">13905285116</div>
        </div>
        <div className="PortContactPopContentWrapper">
          <Space>
            <MailOutlined style={{ fontSize: 14 }} />
            <div className="PortContactPopContentMethod">邮箱</div>
          </Space>
          <div className="PortContactPopContentName">
            supportmaster@keystridevalve.com
          </div>
        </div>
      </div>
    )
  }
}
